import { onMounted, onUnmounted, ref } from 'vue'

export function useHashToToggleModal(hashObjects) {
    const isOpen = ref(false)
    const title = ref('')
    const body = ref('')

    const close = () => {
        isOpen.value = false;
        removeHashFromUrl();
    }

    const handleHashChange = () => {
        const hash = window.location.hash.replace('#', '')
        const matchedModalObject = hashObjects.find((x) => x.anchorId === hash)

        if (matchedModalObject) {
            title.value = matchedModalObject.title;
            body.value = matchedModalObject.description;
            isOpen.value = true;
        }
    }

    const removeHashFromUrl = () => {
        const hash = window.location.hash
        if (hash) {
            const currentURL = window.location.href
            // Remove the hash from the URL
            const urlWithoutHash = currentURL.split('#')[0]

            // Update the browser's address bar
            window.history.replaceState({}, document.title, urlWithoutHash)
        }
    }

    onMounted(() => {
        handleHashChange()
        window.addEventListener('hashchange', handleHashChange, false)
    })

    onUnmounted(() => {
        window.removeEventListener('hashchange', handleHashChange, false)
    })

    return {
        title,
        body,
        isOpen,
        close
    }
}